import React, { useEffect } from 'react';

const BridgePage = () => {

    useEffect(() => {
        // Redirect to the specified URL immediately
        window.location.href = 'https://find-together-app.sslbeta.de/';
    }, []); // Empty dependency array ensures this runs only once when the component mounts

    return null; // No need to return any JSX since it's directly redirecting

    // Uncomment the below if you need to show the maintenance page in the future
    /*
    return (
        <div className="container inner-page-container d-flex flex-column justify-content-center align-items-center" style={{ height: '100vh' }}>
            <h1 className="text-center mb-4">
                Wir freuen uns über Ihr Interesse! Die Web-App steht Ihnen in Kürze zur Verfügung. Aktuell können Sie Find-Together im Google PlayStore herunterladen oder Zugang für den Apple Testflight anfordern.
            </h1>
            <AppsButtonContainer />
        </div>
    );
    */
};

export default BridgePage;
